if (!customElements.get('account-popover')) {
  customElements.define(
    'account-popover',
    class AccountPopover extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('.account-popover__trigger');
        if (!this.trigger) return;

        this.onTriggerClick = this.onTriggerClick.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onViewportChange = this.onViewportChange.bind(this);

        this.trigger.addEventListener('click', this.onTriggerClick);
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onKeydown);
        window.addEventListener('resize', this.onViewportChange);
        window.addEventListener('scroll', this.onViewportChange, { passive: true });
      }

      disconnectedCallback() {
        this.trigger?.removeEventListener('click', this.onTriggerClick);
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onKeydown);
        window.removeEventListener('resize', this.onViewportChange);
        window.removeEventListener('scroll', this.onViewportChange);
      }

      onTriggerClick() {
        this.toggle(!this.hasAttribute('open'));
      }

      onDocumentClick(event) {
        if (!this.contains(event.target)) this.toggle(false);
      }

      onKeydown(event) {
        if (event.key !== 'Escape' || !this.hasAttribute('open')) return;

        this.toggle(false);
        this.trigger.focus();
      }

      onViewportChange() {
        if (this.hasAttribute('open')) this.updateMobilePosition();
      }

      updateMobilePosition() {
        if (window.matchMedia('(min-width: 1024px)').matches) return;

        const triggerRect = this.trigger.getBoundingClientRect();
        const viewportWidth = document.documentElement.clientWidth;
        const screenInset = 16;
        const arrowHalfWidth = 8;
        const panelWidth = viewportWidth - screenInset * 2;
        const triggerCenter = triggerRect.left + triggerRect.width / 2;
        const arrowRight = viewportWidth - screenInset - triggerCenter - arrowHalfWidth;
        const boundedArrowRight = Math.max(8, Math.min(arrowRight, panelWidth - 24));

        this.style.setProperty('--account-popover-top', `${triggerRect.bottom}px`);
        this.style.setProperty('--account-popover-arrow-right', `${boundedArrowRight}px`);
      }

      toggle(open) {
        if (open) this.updateMobilePosition();
        this.toggleAttribute('open', open);
        this.trigger.setAttribute('aria-expanded', String(open));
      }
    }
  );
}
